import React, { useState } from "react";
import ReportFilters from "../components/reportFilter";
import ReportTable from "../components/reportTable";
import { columnsConfig } from "./reportColumns";

const NPAReport: React.FC = () => {
  const [filters, setFilters] = useState({ from: "", to: "" });

  return (
    <div>
      <ReportFilters filters={filters} setFilters={setFilters} />
      <ReportTable
        title="NPA Report"
        endpoint="reports/npa"
        columns={columnsConfig.npaReport}
        filters={filters}
      />
    </div>
  );
};

export default NPAReport;